import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener } from '@angular/core';
import { trigger,  state,  style, transition, animate } from '@angular/animations';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';
import { UserLogged } from 'src/app/core/helpers/userlogged';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/firebase.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, Subject, Subscription } from 'rxjs';
import { ResolutionService } from 'src/app/core/services/resolution.service';
import { finalize, debounceTime } from 'rxjs/operators';
import { ODataResponse } from 'src/app/core/models/odata-response.model';
import { TblWorkerService } from 'src/services/tblWorker.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService ],
  animations: [
    trigger('showInfo', [
      state('1' , style({ transform: 'rotate(180deg)' })),
      state('0', style({ transform: 'rotate(0deg)' })),
      transition('1 => 0', animate('400ms')),
      transition('0 => 1', animate('400ms'))
    ])
  ]
})
export class HeaderComponent implements OnInit, OnDestroy {
  public showHorizontalMenu:boolean = true; 
  public showInfoContent:boolean = false;
  public settings: Settings;
  public menuItems:Array<any>;
  public router: Router;
  username: string;
  userId: number;
  userData: Observable<firebase.User>;
  windowWidth: string;
  private route: ActivatedRoute;
  private resizeSubject = new Subject<void>();
  private resizeSubscription: Subscription;
  constructor(public appSettings:AppSettings, public menuService:MenuService,
    router: Router , route: ActivatedRoute , private angularFireAuth: AngularFireAuth,
    private resolutionService: ResolutionService, private tblWorkerService: TblWorkerService
    ) {
      this.userData = angularFireAuth.authState;
      this.settings = this.appSettings.settings;
      this.menuItems = this.menuService.getHorizontalMenuItems();
      this.router = router;
      
      // Setup debounce cho resize event để tránh gọi API quá nhiều
      this.resizeSubscription = this.resizeSubject.pipe(
        debounceTime(500) // Đợi 500ms sau khi người dùng ngừng resize
      ).subscribe(() => {
        if (this.userId) {
          this.updateSelectedScreen();
        }
      });
  }
  
  ngOnDestroy() {
    // Cleanup subscription để tránh memory leak
    if (this.resizeSubscription) {
      this.resizeSubscription.unsubscribe();
    }
    if (this.resizeSubject) {
      this.resizeSubject.complete();
    }
  }
  
  ngOnInit() {
    if(window.innerWidth <= 768)  {
      this.showHorizontalMenu = false;
    } 
    
    // Tự động nhận diện resolution khi component khởi tạo
    const detectedWidth = window.innerWidth;
    this.windowWidth = `${detectedWidth}`;
    this.resolutionService.setResolution(detectedWidth);

    let userLogged: UserLogged = new UserLogged();
    if (userLogged.isLogged()) {
      let user = userLogged.getCurrentUser();
      this.userId = user.userId;
      this.username = user.userName;
      
      // Lấy SelectedScreen từ backend (nếu có) để so sánh
      let getSelectedScreen = this.tblWorkerService.getUser(this.userId).pipe(
        finalize(() => {
          getSelectedScreen.unsubscribe();
        })
      ).subscribe(
        (res: any) => {
          console.log("Saved screen from backend:", res.SelectedScreen);
          console.log("Current screen width:", detectedWidth);
          
          // Tự động lưu resolution hiện tại vào backend
          // (sử dụng resolution thực tế của màn hình, không dùng giá trị từ backend)
          this.updateSelectedScreen();
        },
        (err) => {
          console.log(err);
          // Nếu có lỗi khi lấy user, vẫn cố gắng lưu resolution
          if (this.userId) {
            this.updateSelectedScreen();
          }
        });
    } else {
      // Nếu chưa login, vẫn set resolution nhưng không lưu backend
      this.resolutionService.setResolution(detectedWidth);
    }
  }


  public closeSubMenus(){
    let menu = document.querySelector("#menu0"); 
    if(menu){
      for (let i = 0; i < menu.children.length; i++) {
          let child = menu.children[i].children[1];
          if(child){          
              if(child.classList.contains('show')){            
                child.classList.remove('show');
                menu.children[i].children[0].classList.add('collapsed'); 
              }             
          }
      }
    }
  }

  @HostListener('window:resize')
  public onWindowResize():void {
     if(window.innerWidth <= 768){
        this.showHorizontalMenu = false;
     }      
      else{
        this.showHorizontalMenu = true;
      }
      
      // Tự động cập nhật resolution khi resize
      const currentWidth = window.innerWidth;
      this.windowWidth = `${currentWidth}`;
      this.resolutionService.setResolution(currentWidth);
      
      // Trigger debounced save to backend
      this.resizeSubject.next();
  }
  logOut() {
    let userLogged: UserLogged = new UserLogged();
    userLogged.logout();
    this.username = '';
  //   this.angularFireAuth
  //   .auth
  //   .signOut();
  //   if (!firebase.apps.length) {
  //     firebase.initializeApp({});
  //  }else {
  //     firebase.app(); // if already initialized, use that one
  //  }
    this.router.navigate(['/login']);
    return false;
  }
  // Method changeResolution đã không còn cần thiết vì đã tự động nhận diện
  // changeResolution(resolution: any) {
  //   const width = parseInt(resolution.target.value, 10);
  //   this.windowWidth = resolution.target.value;
  //   this.resolutionService.setResolution(width);
  //   this.updateSelectedScreen();
  // }
  
  updateSelectedScreen() {
    if (!this.userId) {
      return; // Không lưu nếu chưa login
    }
    
    let formUpdate = {
      "SelectedScreen": this.windowWidth
    }
    let postSortOrder = this.tblWorkerService.upateSelectedScreen(formUpdate, this.userId).pipe(
      finalize(() => {
        postSortOrder.unsubscribe();
      })
    ).subscribe(
      (res: ODataResponse) => { 
        console.log("Resolution saved to backend:", this.windowWidth);
      },
      (err) => {
        console.log(err);
      });
  }
}
